import { createStore } from "vuex"
import usePermissionStore from "@/store/modules/permission";
// ���й���
// const store = createStore({
export default createStore({
    state:{
        testCount: 10,

        user_account: "",
        user_type: "",
        is_login: "false",
        user_role: {
            "menu": ["TestingApplication",""],
            "button": ["add", "delete", "edit", "query"],
        },
    },
    modules:{
        // menu,
    },


    // ��������
    getters:{
        getCount(state){
            return state.testCount > 0 ? state.testCount : "count�����쳣"
        }
    },
    // ͬ������
    mutations:{
        addCount(state, num){
            state.testCount += num
        }
    },
    // �첽������axios
    actions:{
        // addAsyncCount({ commit })
        // {
        //     axios.get("url")
        //         .then(res => {
        //             commit("addCount", res.data[0])
        //         })
        // }

        // async getUserInfo(context) {
        //     try {
        //         const user = await getInfo()
        //         const id = user.data.userId
        //         const userInfo = await getUserInfo(id)
        //         console.log(userInfo)
        //         context.commit('setUserInfo', { ...user.data, ...userInfo.data })
        //         // 09 user�а�����Щҳ���ǿ��Է��ʵ�
        //         console.log(user)
        //         return user.data.roles.menus
        //     }
        //     catch (error) {
        //         throw new Error(error)
        //     }
        // },
    },
})

// export default store;